import React from 'react';
import { StyleSheet } from 'react-native';
import { XStack } from '@tamagui/stacks';
import { X as XIcon, Heart } from 'lucide-react-native';
import { COLORS } from '@/constants/colors';
import IconButton from './IconButton';

const BUTTON_SIZE = 72;
const BUTTON_RADIUS = 36;
const ICON_SIZE = 40;
const BUTTON_SPACING = 50;
const VERTICAL_OFFSET = -20;
const HIT_SLOP = { top: 10, bottom: 10, left: 10, right: 10 };

type SwipeActionsProps = {
  onDiscard: () => void;
  onLike: () => void;
};

const SwipeActions: React.FC<SwipeActionsProps> = ({ onDiscard, onLike }) => {
  return (
    <XStack
      alignItems="center"
      justifyContent="space-between"
      marginTop="$2"
      style={styles.container}
    >
      <IconButton
        accessibilityLabel="Discard"
        onPress={onDiscard}
        style={styles.discardButton}
        hitSlop={HIT_SLOP}
      >
        <XIcon size={ICON_SIZE} color={COLORS.WHITE} />
      </IconButton>

      <IconButton
        accessibilityLabel="Like"
        onPress={onLike}
        style={styles.likeButton}
        hitSlop={HIT_SLOP}
      >
        <Heart size={ICON_SIZE} color={COLORS.ERROR} fill={COLORS.ERROR} />
      </IconButton>
    </XStack>
  );
};

const styles = StyleSheet.create({
  container: {
    position: 'relative',
    top: VERTICAL_OFFSET,
    marginHorizontal: BUTTON_SPACING,
  },
  discardButton: {
    width: BUTTON_SIZE,
    height: BUTTON_SIZE,
    borderRadius: BUTTON_RADIUS,
    backgroundColor: COLORS.ERROR,
  },
  likeButton: {
    width: BUTTON_SIZE,
    height: BUTTON_SIZE,
    borderRadius: BUTTON_RADIUS,
    backgroundColor: COLORS.WHITE,
    borderColor: COLORS.ZINC_900,
    borderWidth: 1,
  },
});

export default SwipeActions;


